import { Link } from 'react-router-dom';

export const redirectToAppointment = () => (
	<div>
		Either account number or mobile number you have mentioned is wrong. Kindly enter correct details or contact to branch
	</div>
);
